import { Link, getRouteApi } from '@tanstack/react-router';
import { CurrentView } from '../../types';
import { useTranslation } from 'react-i18next';

const routeApi = getRouteApi('/tool/');

export function ViewPicker(props: {
    view: CurrentView;
    onSetView: (newView: CurrentView) => void;
}) {
    const { t } = useTranslation();
    const search = routeApi.useSearch();

    return (
        <div
            role="tablist"
            className="tabs tabs-boxed tabs-xs xl:tabs-md flex flex-wrap items-center flex-col md:flex-row justify-start md:justify-center whitespace-nowrap"
        >
            <button
                role="tab"
                aria-selected={props.view === 'bubble'}
                onClick={() => props.onSetView('bubble')}
                className={`tab static ${
                    props.view === 'bubble'
                        ? 'tab-active'
                        : 'text-base-content'
                }`}
            >
                {t('chart')}
            </button>
            <button
                role="tab"
                aria-selected={props.view === 'bubble_and_map'}
                onClick={() => props.onSetView('bubble_and_map')}
                className={`tab static  ${
                    props.view === 'bubble_and_map'
                        ? 'tab-active'
                        : 'text-base-content'
                }`}
            >
                {t('chart-and-map')}
            </button>
            <button
                role="tab"
                aria-selected={props.view === 'map'}
                onClick={() => props.onSetView('map')}
                className={`tab static  ${
                    props.view === 'map' ? 'tab-active' : 'text-base-content'
                }`}
            >
                {t('map')}
            </button>
            <Link
                role="tab"
                aria-selected={false}
                to="/table"
                search={search}
                className="tab static text-base-content"
            >
                {t('table')}
            </Link>
        </div>
    );
}
